var matchTargetWidthModifier = {
  name: "sameWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: function fn(_ref) {
    var state = _ref.state;
    state.styles.popper.width = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref2) {
    var state = _ref2.state;
    state.elements.popper.style.width = "".concat(state.elements.reference.getBoundingClientRect().width, "px");
  }
};
var defaultModifiers = [{
  name: "preventOverflow"
}];
var makeDefaultModifiers = function makeDefaultModifiers(_ref3) {
  var matchTargetWidth = _ref3.matchTargetWidth;

  if (!matchTargetWidth) {
    return defaultModifiers;
  }

  return [].concat(defaultModifiers, [matchTargetWidthModifier]);
};

export { makeDefaultModifiers, matchTargetWidthModifier };
//# sourceMappingURL=popper-modifiers.js.map
